import { Link } from "react-router-dom";
import CollapseHeader from "../../core/common/collapse-header/collapse-header";
import { all_routes } from "../router/all_routes";
import { is_hod } from "../../environment";

const RecruitmentGrid = [
  {
    name: "New Application",
    logo: "../assets/img/dashboard/Leavedashboard.png",
    Link: "/man-power-recruitment",
  },
  {
    name: "View Application",
    logo: "../assets/img/dashboard/Leave-application.png",
    Link: "/view-recruitment",
  },
  {
    name: "Candidate Selection",
    logo: "../assets/img/dashboard/Leave-details.png",
    Link: "/resume-preview",
  },   
  
  ...(is_hod === "true"
    ? [
        {
          name: "Application approval",
          logo: "../assets/img/dashboard/Leave-Report.png",
          Link: "/recruitment-approval",
        },
        // {
        //     name: "Databank",
        //     logo: "../assets/img/dashboard/Leave-Report.png",
        //     Link: "/databank",
        // },
      ]
    : []),
];

const RecruitmentDashBoard = () => {
  return (
    <div className="page-wrapper">
      <div className="content">
        {/* Breadcrumb */}
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Recruitment</h2>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={all_routes.adminDashboard}>
                    <i className="ti ti-smart-home" />
                  </Link>
                </li>
                <li className="breadcrumb-item">Recruitment</li>
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </nav>
          </div>

          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <CollapseHeader />
          </div>
        </div>
        {/* /Breadcrumb */}
        <div className="card">
          <div className="card-body">
            {/* <div className="row">
                            {RecuritmentGrid.map((card, index) => (
                                <div
                                    key={index}
                                    className="col-6 col-sm-4 col-md-3 mb-4 d-flex"
                                >
                                    <Link to={card.Link} className="h-100">
                                        <div className="card h-100 shadow-sm px-2 py-3 px-md-4 px-md-4 d-flex flex-column align-items-center justify-content-center text-center">
                                            <img
                                                src={card.logo}
                                                alt={card.name}
                                                className="mb-3"
                                                style={{
                                                    width: "100px",
                                                    height: "100px",
                                                    objectFit: "contain",
                                                }}
                                            />
                                            <h5 className="mb-0">{card.name}</h5>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div> */}
            <div className="row">
              {RecruitmentGrid.map((card, index) => (
                <div key={index} className="col-6 col-sm-4 col-md-3 mb-4">
                  <Link
                    to={card.Link}
                    className="text-decoration-none h-100 d-block"
                  >
                    <div className="card shadow-sm px-3 py-4 h-100 d-flex flex-column align-items-center justify-content-center text-center">
                      <img
                        src={card.logo}
                        alt={card.name}
                        style={{
                          width: 100,
                          height: 100,
                          objectFit: "contain",
                        }}
                        className="mb-3"
                      />
                      <h5 className="mb-0">{card.name}</h5>
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
        <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
      </div>
    </div>
  );
};

export default RecruitmentDashBoard;
